export const CloakIcon = () => {
    return (
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" width="16.000000" height="16.000000" fill="none">
            <rect id="16 / Alert / Time Stroke" width="16.000000" height="16.000000" x="0.000000" y="0.000000" />
            <path id="Union" d="M13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM7.25 3.99999L7.25 7.87867C7.25 8.4754 7.48705 9.0477 7.90901 9.46966L9.46967 11.0303L10.5303 9.96966L8.96967 8.409C8.82902 8.26834 8.75 8.07758 8.75 7.87867L8.75 3.99999L7.25 3.99999Z" fill="rgb(181,183,192)" fill-rule="evenodd" />
        </svg>
    );
};

